// extracted by mini-css-extract-plugin
export default {"label":"acceptTerms_label__PDDxv","list":"acceptTerms_list__bNUgd","btnContainer":"acceptTerms_btnContainer__EXRmf","error":"acceptTerms_error__5ilMQ"};